import { apiReceive, apiSend } from '@/util/UE/UeInit';

let HC = {
  // 镜头控制器
  CameraControl: {
    /**
     * CmdMoveCamera:移动镜头
     * @param {Object} Camera 镜头参数
     * @param {Object} Camera.Location 目标镜头位置
     * @param {Object} Camera.Rotation 目标镜头旋转值
     * @param {Number} Camera.Time  移动时间,不传默认为1
     * @param {String} Camera.Id Id标识,不传默认为空
     * {
     *    Location:{
     *      X: 0,
     *      Y: 0,
     *      Z: 0,
     *    }
     *     ,
     *     Rotation: {
     *       Pitch: 0,
     *       Yaw: 0,
     *       Roll: 0,
     *     },
     *     Time: 1, 移动时间
     *     Id: "" Id标识
     * }
     *
     * @param {Void} callback 回调处理方法
     */
    CmdMoveCamera: (Camera, callback) => {
      let Parameters = {
        Location: Camera.Location,
        Rotation: Camera.Rotation,
        Time: Camera.Time ? Camera.Time : 1,
        Id: Camera.Id ? Camera.Id : '',
      };
      apiSend('CmdMoveCamera', Parameters);

      apiReceive('CmdMoveCamera', (e) => {
        if (e.Command == 'CmdMoveCamera' && e.Success && callback) {
          callback(e);
        }
      });
    },
    /**
     * CmdGetCameraPos:获取镜头当前位置
     * @param {Void} callback 回调处理方法
     */
    CmdGetCameraPos: (callback) => {
      let Parameters = '';
      apiSend('CmdGetCameraPos', Parameters);

      if (callback) {
        apiReceive('CmdGetCameraPos', (e) => {
          if (e.Command == 'CmdGetCameraPos' && e.Key == 'PawnPos' && e.Success) {
            callback(e.Value);
          }
        });
      } else {
        apiReceive('CmdGetCameraPos', (e) => {
          if (e.Command == 'CmdGetCameraPos' && e.Key == 'PawnPos' && e.Success) {
            console.log(e.Value);
          }
        });
      }
    },
    /**
     * CmdBackStart:获取镜头当前位置
     * @param {Void} callback 回调处理方法
     */
    CmdBackStart: (callback) => {
      let Parameters = '';
      apiSend('CmdBackStart', Parameters);

      if (callback) {
        apiReceive('CmdBackStart', (e) => {
          if (e.Command == 'CmdBackStart' && e.Success) {
            callback(e.Value);
          }
        });
      }
    },
  },
  // 天气控制器
  weatherControl: {
    /**
     * CmdSwitchDayNight：切换昼夜
     * @param {Bool} isNight 为True时，场景将切换至夜晚,否则，场景切换成白天
     */
    CmdSwitchDayNight: (isNight, callback) => {
      let Parameters = {
        isNight: isNight,
      };

      apiSend('CmdSwitchDayNight', Parameters);

      apiReceive('CmdSwitchDayNight', (e) => {
        if (e.Command == 'CmdSwitchDayNight' && e.Success && callback) {
          callback();
        }
      });
    },
    /**
     * CmdSetDayTime：设置天气系统的时间
     * @param {Number} Hour 小时，取值为0-23
     * @param {Number} Minute 分钟，取值为0-59
     */
    CmdSetDayTime: (Hour, Minute = 0, callback) => {
      let Parameters = {
        Hour: Hour,
        Minute: Minute,
      };

      apiSend('CmdSetDayTime', Parameters);

      apiReceive('CmdSetDayTime', (e) => {
        if (e.Command == 'CmdSetDayTime' && e.Success && callback) {
          callback();
        }
      });
    },
    /**
     * CmdControlWeather：天气控制
     * @param {string} WeatherName 天气名称
     *
     * ps: 晴天 ('Sunny')
     *
     * ps: 中雨 ('Rain')
     */
    CmdControlWeather: (WeatherName = '晴天', callback) => {
      let Parameters = {
        WeatherName,
      };

      apiSend('CmdControlWeather', Parameters);

      apiReceive('CmdControlWeather', (e) => {
        if (e.Command == 'CmdControlWeather' && e.Success && callback) {
          callback();
        }
      });
    },
  },
  // 测量工具
  MeasureTools: {
    /**
     * CmdControlTools：4种测量工具
     * @param {string} ToolsName
     * Angle:角度测量
     * Elevation:高度测量
     * Lenth:长度测量
     * Area:面积测量
     * @param {boolean} Status
     * true: 开启
     * false: 关闭
     */
    CmdControlTools: (ToolsName, Status) => {
      let Parameters = '';
      let Command = (Status ? '' : 'End') + 'CmdMeasure' + ToolsName;
      apiSend(Command, JSON.stringify(Parameters));
    },
    /**
     * CmdSkyLine:天际线功能
     * @param {string} Type
     * SkyLine:场景变黑的天际线
     * SkyLine_Real:真实天际线
     * @param {boolean} Status
     * true: 开启
     * false: 关闭
     */
    CmdSkyLine: (Type, Status) => {
      let Parameters = {
        控制器旋转: {
          Pitch: 0,
          Yaw: 0,
          Roll: 0,
        },
        玩家位置: {
          X: 0,
          Y: 0,
          Z: 0,
        },
        Command: 'Create' + Type,
      };
      let Command = (Status ? '' : 'End') + 'CmdSkyLine';
      apiSend(Command, JSON.stringify(Parameters));
    },
    /**
     * CmdVisualFieldDynamic:动态视域分析功能
     * @param {string} Type
     * CreateField:开启创建动态视域
     * DestroyField:摧毁动态视域
     * SwitchFP:切换到当前观测视角
     * SwitchTP:切换到自由观察视角
     * @param {boolean} Status
     * true: 开启
     * false: 关闭
     */
    CmdVisualFieldDynamic: (Type, Status) => {
      let Parameters = {
        Command: Status ? Type : 'DestroyField',
      };
      apiSend('CmdVisualFieldDynamic', JSON.stringify(Parameters));
    },
    /**
     * CmdCounterMap:高度图测量功能
     * @param {boolean} ShowContourLine -- 开启等高线
     * true: 开启
     * false: 关闭
     * @param {boolean} Status
     * true: 开启
     * false: 关闭
     */
    CmdCounterMap: (ShowContourLine, Status) => {
      let Parameters = {
        Alpha: 0.5,
        ContourInterval: 200,
        LineWidth: 10,
        ShowContourLine: ShowContourLine,
      };
      let Command = (Status ? '' : 'End') + 'CmdCounterMap';
      apiSend(Command, JSON.stringify(Parameters));
    },
  },
  // 打点
  poiControl: {
    /**
     * CmdSwitchPoi2DByTemplates：切换类型打点
     * 根据一组打点类型显示/隐藏相应所有打点
     * @param {Array} Templates
     * 类型名称数组
     * @param {Boolean} Show
     * true: 开启
     * false: 关闭
     */
    CmdSwitchPoi2DTitles: (isShow, callback) => {
      let Parameters = {
        Show: isShow,
      };
      apiSend('CmdSwitchPoi2DTitles', Parameters);

      apiReceive('Common', (e) => {
        // console.log("Common回调222", e, e.Key == "OnTitleCheckedChange");
      });

      apiReceive('CmdSwitchPoi2DTitles', (e) => {});
    },
    CmdSwitchPoi2DByTemplates: (isShow, Templates, callback) => {
      let Parameters = {
        Show: isShow,
        Templates: Templates,
      };

      apiSend('CmdSwitchPoi2DByTemplates', Parameters);

      apiReceive('Common', (e) => {
        // console.log("Common回调222", e, e.Key == "OnTitleCheckedChange");

        if (e.Command == '' && e.Key == 'OnTitleCheckedChange' && callback) {
          // console.log("查看是否触发==>", e);
          callback(e);
        }
      });

      apiReceive('CmdSwitchPoi2DByTemplates', (e) => {});
    },
    // 获取勾选的摄像头
    CmdGetAllCheckCamera: (callback) => {
      let Parameters = '';
      apiSend('CmdGetAllCheckCamera', Parameters);

      apiReceive('CmdGetAllCheckCamera', (e) => {
        console.log('CmdGetAllCheckCamera回调', e);

        if (e.Command == 'CmdGetAllCheckCamera' && e.Key == 'AllCheckedCameraResults' && callback) {
          callback(e);
        }
      });
    },
    // 清除勾选
    CmdClearAllCameraTitleChecked: () => {
      let Parameters = '';
      apiSend('CmdClearAllCameraTitleChecked', Parameters);

      apiReceive('CmdClearAllCameraTitleChecked', (e) => {});
    },
  },
  eventControl: {
    /**
     * CmdPlayActionByFileName：通过文件名播放动画
     * @param {String} FileName
     * FileName 动画名称
     */
    CmdPlayActionByFileName: (FileName, callback, call2) => {
      let Parameters = {
        FileName: FileName,
      };

      apiSend('CmdPlayActionByFileName', Parameters);

      apiReceive('Common', (e) => {
        console.log('Common回调', e);
      });

      apiReceive('CmdPlayActionByFileName', (e) => {
        console.log('CmdPlayActionByFileName回调', e);

        if (e.Command == 'CmdPlayActionByFileName' && e.Success && callback) {
          callback(e);
        }
      });

      //
    },
    // 电力显示
    CmdElectric: (isOpen, callback) => {
      let Parameters = '';
      if (isOpen) {
        apiSend('CmdElectric', Parameters);
      } else {
        apiSend('EndCmdElectric', Parameters);
      }

      apiReceive('Common', (e) => {
        console.log('Common回调', e);
      });

      apiReceive('CmdElectric', (e) => {
        console.log('CmdElectric回调', e);

        if (e.Command == 'CmdElectric' && e.Success && callback) {
          callback(e);
        }
      });

      apiReceive('EndCmdElectric', (e) => {
        console.log('EndCmdElectric回调', e);

        if (e.Command == 'EndCmdElectric' && e.Success && callback) {
          callback(e);
        }
      });
    },
    // 楼宇能源
    CmdEnergy: (isOpen, callback) => {
      let Parameters = '';
      if (isOpen) {
        Parameters = {
          Layers: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          Color: [
            {
              X: 0,
              Y: 0,
              Z: 1,
            },
            {
              X: 0,
              Y: 1,
              Z: 1,
            },
            {
              X: 1,
              Y: 0,
              Z: 0,
            },
            {
              X: 1,
              Y: 0,
              Z: 1,
            },
            {
              X: 0,
              Y: 0,
              Z: 1,
            },
            {
              X: 0,
              Y: 1,
              Z: 1,
            },
            {
              X: 1,
              Y: 0,
              Z: 0,
            },
            {
              X: 1,
              Y: 0,
              Z: 1,
            },
            {
              X: 0,
              Y: 0,
              Z: 1,
            },
            {
              X: 0,
              Y: 1,
              Z: 1,
            },
            {
              X: 1,
              Y: 0,
              Z: 0,
            },
            {
              X: 1,
              Y: 0,
              Z: 1,
            },
            {
              X: 0,
              Y: 0,
              Z: 1,
            },
            {
              X: 0,
              Y: 1,
              Z: 1,
            },
            {
              X: 1,
              Y: 0,
              Z: 0,
            },
            {
              X: 1,
              Y: 0,
              Z: 1,
            },
          ],
        };
        apiSend('CmdEnergy', Parameters);
      } else {
        apiSend('EndCmdEnergy', Parameters);
      }

      apiReceive('Common', (e) => {
        console.log('Common回调', e);
      });

      apiReceive('CmdEnergy', (e) => {
        console.log('CmdEnergy回调', e);

        if (e.Command == 'CmdEnergy' && e.Success && callback) {
          callback(e);
        }
      });

      apiReceive('EndCmdEnergy', (e) => {
        console.log('EndCmdEnergy回调', e);

        if (e.Command == 'EndCmdEnergy' && e.Success && callback) {
          callback(e);
        }
      });
    },
    // 场景漫游
    CmdWander: (index, callback) => {
      let Parameters = '';
      switch (index) {
        case 0:
          console.log('1');
          apiSend('CmdWander', Parameters);
          break;
        case 1:
          console.log('2');
          apiSend('CmdWander', Parameters);
          break;
        case -1:
          console.log('-1');
          apiSend('EndCmdWander', Parameters);
          break;
      }

      apiReceive('Common', (e) => {});

      apiReceive('CmdWander', (e) => {
        if (e.Command == 'CmdWander' && e.Success && callback) {
          callback(e);
        }
      });

      apiReceive('EndCmdWander', (e) => {
        if (e.Command == 'EndCmdWander' && e.Success && callback) {
          callback(e);
        }
      });
    },
    // 动环设备
    CmdWarning: (isOpen, callback) => {
      let Parameters = '';
      if (isOpen) {
        apiSend('CmdWarning', Parameters);
      } else {
        apiSend('EndCmdWarning', Parameters);
      }

      apiReceive('Common', (e) => {
        console.log('Common回调', e);
      });

      apiReceive('CmdWarning', (e) => {
        console.log('CmdWarning回调', e);

        if (e.Command == 'CmdWarning' && e.Success && callback) {
          callback(e);
        }
      });

      apiReceive('EndCmdWarning', (e) => {
        console.log('EndCmdWarning回调', e);

        if (e.Command == 'EndCmdWarning' && e.Success && callback) {
          callback(e);
        }
      });
    },
    // 楼宇信息清理
    CmdBuildInfoClear: () => {
      let Parameters = '';
      apiSend('CmdBuildInfoClear', Parameters);
      apiReceive('CmdBuildInfoClear', (e) => {
        console.log('EndCmdWarning回调', e);
      });
      apiReceive('Common', (e) => {
        console.log('Common回调', e);
      });
    },
    //抽出第几层
    // {"Command":"CmdDrawBuilding","Parameters":"{\"BuildingTag\":\"1\",\"FloorIndex\":1,\"Time\":2,\"IsSplite\":true,\"Hide\":true}"}
    CmdDrawBuilding: (index) => {
      let Parameters = {
        BuildingTag: '1号楼',
        FloorIndex: index,
        Time: 2,
      };
      apiSend('CmdDrawBuilding', Parameters);
      apiReceive('CmdDrawBuilding', (e) => {});
      apiReceive('Common', (e) => {});
    },
    //  拆开
    // {"Command":"CmdSplitBuilding","Parameters":"{\"BuildingTag\":\"1\",\"FloorIndex\":1,\"Time\":2,\"IsSplite\":true,\"Hide\":true}"}
    CmdSplitBuilding: (open) => {
      let Parameters = {
        BuildingTag: '1号楼',
        FloorIndex: 0,
        Time: 2,
        IsSplite: open,
        Hide: true,
      };
      apiSend('CmdSplitBuilding', Parameters);
      apiReceive('CmdSplitBuilding', (e) => {});
      apiReceive('Common', (e) => {});
    },
  },
};
window.HC = HC;
export { HC };
